import { useSearchParams } from 'react-router-dom';

import { ButtonPrimary } from '../shared/Buttons';
import { Container, Text, TitleLarge } from './styledComponents';

export default function InvitationAuthenticationPageMoi() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const redirectBuilder = new URL(`${window.location.origin}/user/sign-in`);
  redirectBuilder.searchParams.append('next', `/accept-invite/${token}`);
  const redirectUri = redirectBuilder.toString();

  return (
    <Container narrow>
      <TitleLarge>Welcome!</TitleLarge>
      <Text>Login or create an account to accept your invite.</Text>
      <form method="POST" action="/api/auth-flow">
        <ButtonPrimary
          rounded
          size="medium"
          style={{
            width: '100%',
            marginTop: '2rem',
          }}
        >
          Continue
        </ButtonPrimary>
        <input type="hidden" name="redirect_uri" value={redirectUri} />
        <input type="hidden" name="allow_signup" value="true" />
      </form>
    </Container>
  );
}
